import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimilarTenderComponent } from './similar-tender.component';

import { PipesModule } from '../../../tenders/_pipes/amount-pipes.module';
import { SigninWithOtpModule } from "./../../../auth/_components/signin-with-otp/signin-with-otp.module";

import { WordSlicePipesModule } from '../../../tenders/_pipes/word-slice.pipe.module';

@NgModule({
  declarations: [SimilarTenderComponent,],
  imports: [CommonModule,
    PipesModule,
    SigninWithOtpModule,
    WordSlicePipesModule
  ],
  exports: [SimilarTenderComponent]
})
export class SimilarTenderModule { }